import { Box, Paper } from "@mui/material";
import AcrossLogo from "../../assets/AcrossLogo.png";
import AirtelPaymentBank from "../../assets/APB.png";
import backgroundImage from "../../assets/loginPageBackground.png";
import Footer from "../DashboardLayout/Footer";
import "./index.scss";

const AuthLayout = ({ children }) => {
  return (
    <Box
      component="main"
      className="auth-layout"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Box className="auth-layout__header">
        <div className="auth-layout__logo-container">
          <img
            alt="AirtelLogo"
            className="auth-layout__logo auth-layout__logo--airtel"
            src={AirtelPaymentBank}
          />
          <img
            alt="AcrossLogo"
            src={AcrossLogo}
            className="auth-layout__logo auth-layout__logo--across"
          />
        </div>
      </Box>

      <Paper elevation={6} className="auth-layout__paper">
        {children}
      </Paper>

      <Box className="auth-layout__footer">
        <Footer />
      </Box>
    </Box>
  );
};

export default AuthLayout;
